import * as api from '../../api'
import { Notification } from 'element-ui';
const tags = {
  state: {
    tagsTree: [],
    matterTagsTree: []
  },
  mutations: {
    SET_TAGS_DATA: (state, value) => {
      state.tagsTree = value
    },
    SET_MATTERTAGS_DATA: (state, value) => {
      state.matterTagsTree = value
    },

  },
  actions: {
    //获取标签
    GET_TAGS_DATA: (context, option) => {
      api._post(_TAGSURL_ + 'api/tag/get_tag', option).then((resp) => {
        if (resp.code == 200) {
          if (resp.data) {
            context.commit('SET_TAGS_DATA', getTagsTreeData(resp.data))
          }
        } else {
          context.commit('SET_TAGS_DATA', [])
        }
      }).catch((error) => {
        console.log(error)
      })
      var getTagsTreeData = function (data) {
        // 循环遍历json数据
        for (var i = 0; i < data.length; i++) {

          if (data[i].children.length < 1) {
            // children若为空数组，则将children设为undefined
            data[i].children = undefined;
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            getTagsTreeData(data[i].children);
          }
        }
        return data;
      }

    },

    //获取素材标签  
    GET_MATTERTAGS_DATA: (context, option) => {
      api._post(_MATTERYURL_ + 'get_tag', option).then((resp) => {
        if (resp.code == 200) {
          if (resp.data) {
            context.commit('SET_MATTERTAGS_DATA', getTagsTreeData(resp.data))
          }
        } else {
          context.commit('SET_MATTERTAGS_DATA', [])
        }
      }).catch((error) => {
        console.log(error)
      })
      var getTagsTreeData = function (data) {
        // 循环遍历json数据
        for (var i = 0; i < data.length; i++) {

          if (data[i].children.length < 1) {
            // children若为空数组，则将children设为undefined
            data[i].children = undefined;
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            getTagsTreeData(data[i].children);
          }
        }
        return data;
      }

    },






  }
}

export default tags
